export function contactIdFromNotificationData(data = {}) {
  return data.contact_user_id || data.subject_user_id || data.from_user_id || null;
}
